import SEO from "@/components/SEO";
import Breadcrumbs from "@/components/Breadcrumbs";

export default function About() {
  return (
    <div data-testid="about-page">
      <SEO title="About Point Penta" description="Twelve years of Dubai. A boutique brokerage that treats every mandate like a private client." path="/about" />
      <section className="pt-6 pb-14 border-b border-neutral-200">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
          <Breadcrumbs items={[{ name: "Home", path: "/" }, { name: "About", path: "/about" }]} />
          <div className="overline text-[#001588] mb-4">About Point Penta</div>
          <h1 className="font-serif text-5xl lg:text-7xl leading-tight max-w-4xl">A small brokerage<br/><span className="italic text-neutral-600">with a long memory.</span></h1>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12 grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <img src="https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&w=1200" alt="Dubai skyline at sunset" className="w-full h-full object-cover" />
          </div>
          <div className="md:col-span-7 space-y-6 text-neutral-700 leading-relaxed text-lg">
            <p>Point Penta Real Estate LLC was founded in 2013 in Dubai with a single idea: the brokerage most of our founders would want to hire, didn't yet exist. The market was full of portals and lead-farms. It was short of advisors.</p>
            <p>Twelve years and hundreds of mandates later, we're still a boutique — deliberately. Our advisors carry curated inventories, not indexed ones. Every mandate gets partner-level attention. Every buyer gets a full picture, including the parts other brokers might not want them to see.</p>
            <p>We speak seven languages between us. We represent private owners, family offices, developer principals and institutional investors. And we still remember the name of every family we've placed in Downtown Dubai since 2015.</p>
          </div>
        </div>
      </section>

      <section className="py-24 border-t border-neutral-100 bg-[#ffffff]">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
          <div className="overline text-[#001588] mb-4">By the numbers</div>
          <h2 className="font-serif text-4xl lg:text-5xl leading-tight mb-12">Twelve years of Dubai.</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {[
              ["AED 4.2B", "Transacted"],
              ["620+", "Families placed"],
              ["18", "Community desks"],
              ["7", "Languages spoken"],
            ].map(([v, k]) => (
              <div key={k} className="border-t border-neutral-300 pt-6">
                <div className="font-serif text-5xl text-[#001588]">{v}</div>
                <div className="overline text-neutral-500 mt-2">{k}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
